export const loginPageMessages = {
  LOGIN_PAGE: {
    LINEAR_GRADIENT: {
      LABEL1: 'A SHIFT LEFT PARADIGM',
      LABEL2:
        ' Pragmatic and evidence-based transformation of health management from reactive to proactive',
    },
    ERROR_MESSAGES: {
      EMAIL_EMPTY: 'Email cannot be empty',
      INVALID_EMAIL: 'Invalid Email',
      INVALID_PASSWORD: 'Minimum 8 characters',
      INVALID_CREDENTIALS: 'Invalid email or password',
      PASSWORD_EMPTY:'Password cannot be empty',
      GOOGLE_LOGIN_ERROR: 'Not able to access google login'
    },
  },
};
